import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getDbsCycle = async (choice, cyc_name) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `dbs/cycle/${choice}/${cyc_name}`,
      {},
      false,
      null,
      "Migrated"
    );
    store.commit("dbs/setCycle", resp.data.cycle_info);
  } catch (err) {
    console.log('ERROR"" getDbsCycle()');
    throw err;
  }
};
